import { storage } from 'APP/packages/storage';
import { TChatBackground } from 'APP/store/Appearance/Appearance.types';
import Entities from 'STORE';

export function setGlobalChatBackground(chatBackground: TChatBackground): void {
  const userId = Entities.usersStore.myId;
  if (!userId) {
    return;
  }
  Entities.appearance.setChatBackgroundGlobal(chatBackground);
  storage.chatBackgroundGlobal.set(chatBackground, userId);
}
